const ITEMS = [
  "Restorative Dermatology",
  "IPL Photofacial",
  "Precision Microneedling",
  "Botanical Integrity",
  "Hydrafacial Infusion",
  "Chemical Peels",
  "Permanent Hair Removal",
  "Dermaplaning Polish",
];

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="bg-sand border-y border-[#E5DDD0] overflow-hidden py-4"
    >
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex shrink-0" aria-hidden={dup === 1}>
            {ITEMS.map((t) => (
              <span
                key={`${dup}-${t}`}
                className="mx-8 flex items-center gap-16 text-xs uppercase tracking-[0.3em] text-ink/60 font-semibold"
              >
                {t}
                <span className="text-clay text-sm">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
